module.exports = __webpack_public_path__ + "static/media/notfound.88d37631.jpg";